import React from 'react';

import Tooltip from '../tooltip';

import './index.scss';

interface LoadDocBtnProps {
  title: string;
  onSpecDownload?: () => void;
  onSpecDownloadSig?: () => void;
  sig?: boolean;
  extension?: string;
  sm?: boolean;
  lg?: boolean;
}

const LoadDocBtn: React.FC<LoadDocBtnProps> = ({
  title,
  onSpecDownload,
  onSpecDownloadSig,
  sig,
  extension = '.PDF',
  sm = true,
  lg,
}) => (
  <div className="doc-btn__container">
    <div
      className={`doc-btn${sm ? ' doc-btn__sm' : ''}${
        lg ? ' doc-btn__lg' : ''
      }`}
    >
      <div className="doc-title">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M9.33329 1.33325H3.99996C3.64634 1.33325 3.3072 1.47373 3.05715 1.72378C2.8071 1.97382 2.66663 2.31296 2.66663 2.66659V13.3333C2.66663 13.6869 2.8071 14.026 3.05715 14.2761C3.3072 14.5261 3.64634 14.6666 3.99996 14.6666H12C12.3536 14.6666 12.6927 14.5261 12.9428 14.2761C13.1928 14.026 13.3333 13.6869 13.3333 13.3333V5.33325L9.33329 1.33325Z"
            stroke="#444444"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.33337 1.33325V5.33325H13.3334"
            stroke="#444444"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.6667 8.66675H5.33337"
            stroke="#444444"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.6667 11.3333H5.33337"
            stroke="#444444"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.66671 6H6.00004H5.33337"
            stroke="#444444"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        {title}
      </div>
      <div className="doc-btn-container">
        <div onClick={onSpecDownload}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
              stroke="#444444"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.66663 6.66675L7.99996 10.0001L11.3333 6.66675"
              stroke="#444444"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8 10V2"
              stroke="#444444"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          {extension}
        </div>
        {sig && (
          <div onClick={onSpecDownloadSig}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
                stroke="#444444"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M4.66663 6.66675L7.99996 10.0001L11.3333 6.66675"
                stroke="#444444"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8 10V2"
                stroke="#444444"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            .SIG
          </div>
        )}
      </div>
    </div>
    {sig && (
      <Tooltip
        title={
          <>
            Вы можете проверить подпись документа на сайте{' '}
            <a
              href="https://crypto.kontur.ru/verify"
              target="_blank"
              rel="noreferrer"
            >
              crypto.kontur.ru
            </a>
          </>
        }
        placement="top-end"
        isCloseClick
      >
        <div>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M9.99996 18.3333C14.6023 18.3333 18.3333 14.6023 18.3333 9.99996C18.3333 5.39759 14.6023 1.66663 9.99996 1.66663C5.39759 1.66663 1.66663 5.39759 1.66663 9.99996C1.66663 14.6023 5.39759 18.3333 9.99996 18.3333Z"
              stroke="#96B1FE"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.5 7.50377C7.69592 6.94683 8.08263 6.47719 8.59163 6.17805C9.10063 5.8789 9.69908 5.76955 10.281 5.86936C10.8629 5.96918 11.3907 6.27171 11.7709 6.72338C12.1511 7.17505 12.3592 7.74671 12.3583 8.3371C12.3583 10.0038 10 10.8334 10 10.8334V12.0834"
              stroke="#96B1FE"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10 14.1666H10.0083"
              stroke="#96B1FE"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Как проверить подпись
        </div>
      </Tooltip>
    )}
  </div>
);

export default LoadDocBtn;
